(() => {
  const ROOT = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  const LANG = (document.documentElement.lang || '').toLowerCase();
  const COPY = LANG.startsWith('de')
    ? {
        add: 'Hinzufügen',
        adding: 'Wird hinzugefügt…',
        added: 'Hinzugefügt ✓',
        addedStatus: 'Zum Warenkorb hinzugefügt.',
        addAnother: 'Noch eins hinzufügen',
        retry: 'Erneut versuchen',
        error: 'Hinzufügen fehlgeschlagen. Bitte versuche es erneut.'
      }
    : {
        add: 'Toevoegen',
        adding: 'Toevoegen…',
        added: 'Toegevoegd ✓',
        addedStatus: 'Toegevoegd aan je winkelwagen.',
        addAnother: 'Nog één toevoegen',
        retry: 'Probeer opnieuw',
        error: 'Toevoegen lukte niet. Probeer het opnieuw.'
      };

  const updateCartCount = (cart) => {
    if (!cart || typeof cart.item_count !== 'number') return;

    document.querySelectorAll('[data-cart-count]').forEach((node) => {
      node.textContent = String(cart.item_count);
      node.hidden = cart.item_count < 1;
    });

    document.querySelectorAll('.cart-count-bubble').forEach((bubble) => {
      const number = bubble.querySelector('span[aria-hidden="true"]') || bubble.querySelector('span');
      if (number) number.textContent = String(cart.item_count);
      bubble.hidden = cart.item_count < 1;
    });
  };

  const refreshCart = async () => {
    try {
      const response = await fetch(`${ROOT}cart.js`, {
        headers: { Accept: 'application/json' },
        credentials: 'same-origin'
      });
      if (!response.ok) return null;
      const cart = await response.json();
      updateCartCount(cart);
      document.dispatchEvent(new CustomEvent('cart:updated', { detail: { cart } }));
      document.dispatchEvent(new CustomEvent('cart:refresh', { detail: { cart } }));
      return cart;
    } catch (_) {
      return null;
    }
  };

  const bindForm = (form) => {
    if (!form || form.dataset.lcxsBound === 'true') return;
    form.dataset.lcxsBound = 'true';

    form.addEventListener('submit', async (event) => {
      if (!window.fetch) return;

      event.preventDefault();

      const button = form.querySelector('[data-lcxs-add]');
      const label = form.querySelector('[data-lcxs-label]');
      const status = form.closest('[data-lcxs-card]')?.querySelector('[data-lcxs-status]');
      const card = form.closest('[data-lcxs-card]');
      const variantInput = form.querySelector('input[name="id"]');
      const variantId = Number(variantInput?.value);

      if (!button || !label || !variantId) {
        form.submit();
        return;
      }

      const defaultLabel = label.textContent?.trim() || COPY.add;
      button.disabled = true;
      label.textContent = COPY.adding;
      if (status) status.textContent = '';

      try {
        const response = await fetch(`${ROOT}cart/add.js`, {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            Accept: 'application/json'
          },
          credentials: 'same-origin',
          body: JSON.stringify({
            items: [{ id: variantId, quantity: 1 }]
          })
        });

        if (!response.ok) {
          throw new Error('Cart add failed');
        }

        card?.classList.add('is-added');
        label.textContent = COPY.added;
        if (status) status.textContent = COPY.addedStatus;
        await refreshCart();

        window.setTimeout(() => {
          button.disabled = false;
          label.textContent = COPY.addAnother;
        }, 900);
      } catch (_) {
        card?.classList.remove('is-added');
        button.disabled = false;
        label.textContent = COPY.retry;
        if (status) status.textContent = COPY.error;

        window.setTimeout(() => {
          label.textContent = defaultLabel;
        }, 2600);
      }
    });
  };

  const init = () => {
    document.querySelectorAll('[data-lcxs-form]').forEach(bindForm);
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init, { once: true });
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', init);
})();
